import { useEffect, useState } from 'react';
import { BATTLES_TAB_CURRENT_INFO_ID } from '../constants';
import { isNotStandaloneMobilePWA } from '../../../utils/mobileSupported';
import { isTablet } from 'react-device-detect';

function useBattlesTabContainerStyleCalculator() {
  const [containerStyle, setContainerStyle] = useState({
    height: 200,
    position: 'relative',
    width: '100%',
    paddingTop: 0,
    marginBottom: isNotStandaloneMobilePWA && !isTablet ? -25 : 'unset',
    marginTop: isNotStandaloneMobilePWA && !isTablet ? 10 : 'unset',
  });
  const [tabBackgroundHeight, setTabBackgroundHeight] = useState(0);

  useEffect(() => {
    const targetElement = document.getElementById(BATTLES_TAB_CURRENT_INFO_ID);
    if (!targetElement) return;

    const updateScale = () => {
      const height = targetElement.clientHeight;
      setContainerStyle(prevContainerStyle => ({ ...prevContainerStyle, height }));
      setTabBackgroundHeight(height);
    };
    updateScale();
    const observer = new ResizeObserver(updateScale);
    observer.observe(targetElement);
    return () => observer.disconnect();
  }, []);

  return {
    containerStyle,
    tabBackgroundHeight,
  };
}

export default useBattlesTabContainerStyleCalculator;

